import { useState, useCallback } from "react";
import axios from "axios";
import Api from "../Api/Api.json";

export const useLaunchComputeResource = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const getCurrentIP = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error fetching IP:', error);
      // Fallback to a default IP or handle error as needed
      return '127.0.0.1';
    }
  };

  const launchComputeResource = useCallback(async (token) => {
    if (!token) {
      setError('No authentication token provided');
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      // Get current IP address
      const currentIP = await getCurrentIP();
      
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const requestData = {
        task: "start_code_server",
        ip: currentIP,
      };

      // Debug logs: request details (mask token)
      try {
        console.log('[launchComputeResource] Endpoint:', Api.UPSKILL_AUTH);
        console.log('[launchComputeResource] Request Body:', requestData);
        console.log('[launchComputeResource] Headers:', {
          ...headers,
          Authorization: `Bearer ${'*'.repeat(Math.max(0, (token?.length || 0) - 6))}${token?.slice(-6) || ''}`,
        });
      } catch (_) {}

      const response = await axios.post(Api.UPSKILL_AUTH, requestData, {
        headers,
      });

      // Debug logs: response details
      try {
        console.log('[launchComputeResource] Response Status:', response.status);
        console.log('[launchComputeResource] Response Data Type:', typeof response.data);
        console.log('[launchComputeResource] Response Data:', response.data);
      } catch (_) {}

      setData(response.data);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Failed to launch compute resource';
      setError(errorMessage);
      console.error('[launchComputeResource] Error launching compute resource:', err?.response || err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    launchComputeResource,
    isLoading,
    error,
    data,
  };
};
